import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { CategoryService } from "./category.service";

// export const dynamic = "force-dynamic";

const initialState = {
  categories: [],
  category: null,
  success: false,
  isLoading: false,
  error: null,
  message: null,
};

export const addCategory = createAsyncThunk(
  "category/addCategory",
  async (data, { rejectWithValue, getState }) => {
    try {
      const _categoryService = new CategoryService();
      const response = await _categoryService.addCategory(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getCategories = createAsyncThunk(
  "category/getCategories",
  async (_, { rejectWithValue, getState }) => {
    try {
      const _categoryService = new CategoryService();
      const response = await _categoryService.getCategories();
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCategory = createAsyncThunk(
  "category/updateCategory",
  async (data, { rejectWithValue, getState }) => {
    try {
      const _categoryService = new CategoryService();
      const response = await _categoryService.updateCategory(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "category/deleteCategory",
  async (id, { rejectWithValue, getState }) => {
    try {
      const _categoryService = new CategoryService();
      const response = await _categoryService.deleteCategory(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    reset: (state) => {
      state.category = null;
      state.success = false;
      state.isLoading = false;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCategories.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCategories.fulfilled, (state, action) => {
      state.isLoading = false;
      const payload = action.payload?.data;
      state.categories = Array.isArray(payload) ? payload : [];
    });
    builder.addCase(getCategories.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload?.message || "Failed to load categories";
    });

    builder.addCase(addCategory.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(addCategory.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.category = action.payload?.data;
      state.message = action.payload?.message || "Category created successfully";
    });
    builder.addCase(addCategory.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Failed to add category";
    });

    builder.addCase(updateCategory.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(updateCategory.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.category = action.payload?.data;
      state.message = action.payload?.message || "Category updated successfully";
    });
    builder.addCase(updateCategory.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Failed to update category";
    });

    builder.addCase(deleteCategory.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(deleteCategory.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.message = action.payload?.message || "Category deleted successfully";
    });
    builder.addCase(deleteCategory.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Failed to delete category";
    });
  },
});

export const { reset } = categorySlice.actions;

export default categorySlice.reducer;
